import { DELETE, GET, POST, PUT } from './'
import { ajax } from '../../ajax'
import { getLang } from '@spa/utils/gettext'

const basePath = '/api-deprecated/service-appointment'

export const getUserData = (
  realizedForId,
  ticketId,
  defaultResearchGroup,
  defaultProject,
  defaultRealizedFor
) => ajax({
  method: GET,
  url: `${basePath}/user-data`,
  params: { lang: getLang(), realizedForId, ticketId, defaultResearchGroup, defaultProject, defaultRealizedFor }
})

/**
 * @param {object} data
 * @param {function|null} onError
 */
export const createServiceAppointment = (data, onError = null) => ajax({
  method: POST,
  url: `${basePath}/`,
  data,
  suppressErrorAlert: true
}, onError)

/**
 * @param {string} id
 * @param {object} data
 * @param {function|null} onError
 */
export const updateServiceAppointment = (id, data, onError = null) => ajax({
  method: PUT,
  url: `${basePath}/${id}/`,
  data,
  suppressErrorAlert: true
}, onError)

export const deleteServiceAppointment = (serviceAppointmentId) => ajax({
  method: DELETE,
  url: `${basePath}/${serviceAppointmentId}/`,
})

export const getServiceAppointment = (serviceAppointmentId) => ajax({
  method: GET,
  url: `${basePath}/${serviceAppointmentId}/`,
})

export const listServiceAppointments = (params) => ajax({
  method: GET,
  url: `${basePath}/`,
  params,
})

export const hasUserAccess = (id, onError) => ajax({
  method: GET,
  url: `${basePath}/${id}/check-user-access/`
}, onError)

export const getServiceAppointmentAdditionalContacts = (id, onError) => ajax({
  method: GET,
  url: `${basePath}/${id}/additional-contacts/`
}, onError)

export const getServiceAppointmentPrices = (params) => ajax({
  method: GET,
  url: `${basePath}/prices/`,
  params,
})
